export default __webpack_public_path__ + "static/media/edit_icon.6466226a.svg";